<template>
    <header>
        <div class="logo" @click="goHome()"/>
    </header>
    <main>
        <nav>tbd</nav>
        <OnlineStatus/>
        <div v-if="storeInitialized">
            <transition appear name="next" mode="out-in">
                <component :is="component"
                           @updateComponent="setComponent(true)"></component>
            </transition>
        </div>
    </main>
    <footer>
        <div class="footer-contents">
            &copy;{{ year }} <a href="https://upgrait.com/heatcontrol/" target="_blank">UPGRAIT GmbH</a> | <a href="https://upgrait.com/impressum/" target="_blank">Impressum</a> | <a
            href="https://upgrait.com/datenschutz/" target="_blank">Datenschutz</a><br/>
            <small>App-Version {{ $core.getConfig().versionNumber }}</small>
            <template v-if="$core.getConfig().codeName"> ({{ $core.getConfig().codeName }})</template>
        </div>
    </footer>
</template>

<script>
import Setup        from "@/components/setup/Setup.vue";
import Dashboard    from "@/components/routes/dashboard/Dashboard.vue";
import Delivery     from "@/components/routes/delivery/Delivery.vue";
import Statistics   from "@/components/routes/statistics/Statistics.vue";
import Settings     from "@/components/routes/settings/Settings.vue";
import Status       from "@/components/routes/status/Status.vue";
import OnlineStatus from "@/components/parts/OnlineStatus.vue";

export default {

    name      : 'App',
    components: { OnlineStatus, Dashboard, Delivery, Setup, Statistics, Settings, Status },
    data()
    {
        return {
            provisioned     : false,
            component       : 'Setup',
            storeInitialized: false,
            year            : new Date().getFullYear()
        }
    },

    created()
    {

        if( true === this.$store.getters.storeInitialized )
        {
            this.setComponent()
            this.storeInitialized = true
        }
        else
        {
            this.$core.getEventManager()
                .addIndexed( 'on-store-initialized', () =>
                {
                    this.setComponent()
                    this.storeInitialized = true
                } )
        }
    },

    watch: {
        "$route.name": {
            immediate: true,
            handler()
            {
                this.setComponent()
            }
        }
    },

    methods: {
        setComponent( byTrigger )
        {
            if( this.$store.getters.serial !== false )
            {
                switch( this.$route.name )
                {
                    case 'settings':
                        this.component = 'Settings'
                        break
                    case 'statistics':
                        this.component = 'Statistics'
                        break
                    case 'delivery':
                        this.component = 'Delivery'
                        break
                    case 'status':
                        this.component = 'Status'
                        break
                    default:
                        this.component = 'Dashboard'
                }
            }
            else
            {
                this.component = 'Setup'
            }
        },
        goHome()
        {
            this.$router.push( { name: 'dashboard' } )
        }
    }
}
</script>


<style lang="less">
@import './less/ui';
</style>
